import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import axios from 'axios';
import BASE_URL from '../../utils/api';
import { FaArrowLeft, FaArrowRight, FaStar, FaTag } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './slider.css';


const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="arrow next" onClick={onClick}>
      <FaArrowRight />
    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="arrow prev" onClick={onClick}>
      <FaArrowLeft />
    </div>
  );
};

export default function ProductSlider() {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/products`);
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 3 } },
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="dark-product-slider">
      <Slider {...settings}>
        {products.map((item) => (
          <div className="slide-padding" key={item._id}>
            <div
              className="product-card"
              onClick={() => navigate(`/product/${item._id}`)}
              style={{ cursor: 'pointer' }} // Makes it look clickable
            >
              <img src={item.productImages[0]} alt={item.productName} className="product-image" />
              <div className="product-content">
                <h3 className="product-title">{item.productName}</h3>
                <div className="product-meta">
                  <span className="product-price">LKR {item.productPrice?.$numberDecimal || '999'}</span>
                  <div className="product-rating">
                    <FaStar className="star-icon" />
                    4.8
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
